import React from 'react'
import {gql,useQuery} from "@apollo/client";

const GET_PEDIDOS = gql`
query getPedidos{
  getPedidos{
    _id
    estado
    numeroPedido
    nombreCliente
    direccionCliente
    whatsappCliente
    notaPedido
    productos
  }
}`

function Pedidos () {
    const {loading, error, data} = useQuery(GET_PEDIDOS);
    if(loading) return <p>Esperando resultados...</p>;
    if(error) return <p>Error</p>;
  
  
  
   console.log(data);
  
   const pedidos = data.getPedidos ;

    return(
        <div>
            {pedidos && pedidos.map((pedido) => (
        <div key={pedido._id}>
          <h1>Número de Pedido: {pedido.numeroPedido}</h1>
          <h2>Estado: {pedido.estado}</h2>
          <p>Nombre del Cliente: {pedido.nombreCliente}</p>
          <p>Dirección del Cliente: {pedido.direccionCliente}</p>
          <p>WhatsApp del Cliente: {pedido.whatsappCliente}</p>
          <p>Nota del Pedido: {pedido.notaPedido}</p>
          <h3>Productos:</h3>
          <ul>
          {pedido.productos && JSON.parse(pedido.productos).map((producto) => (
              <li key={producto.id}>{producto.nombre} <h1>{producto.precio}</h1></li>
             

            ))}
          </ul>
        </div>
      ))}
        </div>
    )
}

export default Pedidos;